if (!customElements.get("pcard-swatch")) {
    class PcardColorSwatch extends HTMLElement {
        constructor() {
            super(),
            this.selectors = {
                container: "[data-pcard-variant-picker]",
                optionNodes: [".m-product-option--node__label"],
                featuredImage: ".m-product-card__main-image",
                pcard: ".m-product-card",
                variantDropdown: ".m-product-option--dropdown-select",
                priceWrapper: ".m-price",
                salePrice: ".m-price-item--sale",
                compareAtPrice: [".m-price-item--regular"],
                unitPrice: ".m-price__unit",
                soldOutBadge: ".m-product-tag--soldout",
                discountBadge:"[data-discount-badge]"
            },
            this.container = this.closest(this.selectors.container),
            this.pcard = this.closest(this.selectors.pcard),
            this.variantIdNode = this.pcard && this.pcard.querySelector('[name="id"]'),
            this.atcBtn =this.pcard.querySelector('.m-add-to-cart'),
            this.featuredImage = this.pcard && this.pcard.querySelector(this.selectors.featuredImage),
            this.domNodes = queryDomNodes(this.selectors, this.pcard),
            this.setupData();
            setTimeout(function(){
              if(this.querySelector('[data-store-code]')){
                this.querySelector('[data-store-code]').click();
              }
            }.bind(this),1000)
        }
        async setupData() {
            this.variantData = this.getVariantData(),
            this.productHandle = this.container.dataset.productHandle,
            this.productData = await this.getProductJson(),
            this.activeOptionNodeByPosition = {},
            this.hide_unavailable_product_options = MinimogSettings.hide_unavailable_product_options;
            const {variantIdNode, productData, productData: {variants}={}} = this;
            if (productData) {
                let currentVariantId = variantIdNode && Number(variantIdNode.value);
                // currentVariantId || (currentVariantId = productData.selected_or_first_available_variant && productData.selected_or_first_available_variant.id);
                const currentVariant = this.variantData.find(function(v){
                  if(v.available == true){
                    return v;
                  }
                }) || this.variantData[0];
                this.currentVariant = currentVariant;
                this.productData.initialVariant = currentVariant;
                !this.productData.selected_variant && variantIdNode && variantIdNode.dataset.selectedVariant && (this.productData.selected_variant = variants.find(v => v.id === Number(variantIdNode && variantIdNode.dataset.selectedVariant))),
                this.updateOptionByVariant(currentVariant),
                window.MinimogEvents.subscribe("m:image-loaded", () => {
                    this.changeProductImage(currentVariant)
                }
                )
            }
            this.initOptionSwatches(),
              this.hideSoldOutAndUnavailableOptions(),
              console.log('this.domNodes.optionNodes',this.domNodes.optionNodes),
            this.domNodes.optionNodes && this.domNodes.optionNodes.forEach(node => node.addEventListener("click", this.handleSelectVariant.bind(this))),
            this.domNodes.variantDropdown && this.domNodes.variantDropdown.addEventListener("change", this.handleSelectVariant.bind(this))
        }
        getVariantData() {
            return this.variantData = this.variantData || JSON.parse(this.container && this.container.querySelector('[type="application/json"]').textContent),
            this.variantData
        }
        getProductJson() {
            let productUrl = `${window.MinimogSettings.routes.root}/products/${this.productHandle}.js`;
            return productUrl = productUrl.replace("//", "/"),
            fetch(productUrl).then(function(response) {
                return response.json()
            })
        }
        initOptionSwatches() {
            const {_colorSwatches=[], _imageSwatches=[]} = window.MinimogSettings;
            this.domNodes.optionNodes.forEach(optNode => {
                const {optionType, optionPosition, value: optionValue} = optNode && optNode.dataset
                  , optionValueLowerCase = optionValue && optionValue.toLowerCase()
                  , variantToShowSwatchImage = this.variantData.find(v => v[`option${optionPosition}`] === optionValue)
                  , variantImage = variantToShowSwatchImage && variantToShowSwatchImage.featured_image && variantToShowSwatchImage.featured_image.src ? getSizedImageUrl(variantToShowSwatchImage.featured_image.src, "60x") : null
                  , customImage = _imageSwatches.find(i => i.key === optionValueLowerCase) && _imageSwatches.find(i => i.key === optionValueLowerCase).value
                  , customColor = _colorSwatches.find(c => c.key === optionValueLowerCase) && _colorSwatches.find(c => c.key === optionValueLowerCase).value;
                switch ((variantImage || customImage) && optNode.classList.add("has-bg-img"),
                optionType) {
                case "default":
                    (customImage || variantImage) && (optNode.style.backgroundImage = `url(${customImage || variantImage || ""})`);
                    break;
                case "image":
                    (variantImage || customImage) && (optNode.style.backgroundImage = `url(${variantImage || customImage || ""})`);
                    break;
                case "color":
                    optNode.style.background = `${customColor || optionValueLowerCase}`,
                    customImage && (optNode.style.backgroundImage = `url(${customImage})`);
                    break;
                default:
                    break
                }
            }
            )
        }
        toggleOptionNodeActive(optNode, active) {
            if (optNode)
                if (active) {
                    const {optionPosition, value: optionValue} = optNode.dataset;
                    switch (this.activeOptionNodeByPosition[optionPosition] = optNode,
                    optNode.tagName) {
                    case "INPUT":
                        optNode.checked = "checked",
                        optNode.dataset.selected = "true";
                        break;
                    case "OPTION":
                        optNode.dataset.selected = "true";
                        const select = optNode.closest("select");
                        select && (select.value = optNode.value);
                        break;
                    case "LABEL":
                        optNode.dataset.selected = "true";
                        break;
                    default:
                        optNode.classList.contains("m-product-quickview-button") || console.warn("Unable to activate option node", optNode);
                        break
                    }
                    this.updateSoldOutBadge(this.getVariantsByActiveOptionValue(optionValue))
                } else {
                    ["default", "image", "color"].includes(optNode.dataset.optionType) || (optNode.style.border = ""),
                    optNode.checked = !1,
                    delete optNode.dataset.selected;
                    const select = optNode.closest("select");
                    select && (select.value = "")
                }
        }
        updateOptionByVariant(variant) {
            Object.values(this.activeOptionNodeByPosition).forEach(optNode => this.toggleOptionNodeActive(optNode, !1));
            const {optionNodes} = this.domNodes
              , {options=[]} = variant || {};
            options.forEach( (option, index) => {
                const optPosition = index + 1;
                optionNodes.forEach(optNode => {
                    const _optPosition = Number(optNode.dataset.optionPosition)
                      , _optValue = optNode.dataset.value;
                    _optPosition === optPosition && option === _optValue && this.toggleOptionNodeActive(optNode, !0)
                }
                )
            }
            ),
            this.updatePrice(variant)
        }
        getVariantFromActiveOptions = () => {
            const {variantData, productData: {initialVariant}, activeOptionNodeByPosition} = this;
            let options;
            const initialVariantOptions = {
                1: this.variantData[0].option1,
                2: this.variantData[0].option2,
                3: this.variantData[0].option3
            };
            Object.values(activeOptionNodeByPosition).forEach(optNode => {
                const {optionPosition, value} = optNode.dataset;
                initialVariantOptions[optionPosition] = value
            }
            );
            options = Object.values(initialVariantOptions),
            options = options.filter(Boolean);
            let variant = getVariantFromOptionArrayCustom(this.variantData, options);
            return !variant && this.hide_unavailable_product_options && (options.pop(),
            variant = getVariantFromOptionArrayCustom(this.variantData, options),
            variant || (options.pop(),
            variant = getVariantFromOptionArrayCustom(this.variantData, options))),
            this.currentVariant = variant,
            variant
        }
        ;
        handleSelectVariant(e) {
            console.log('e',e);
            let {target} = e, newVariant;
            if (target.classList.contains("combined-variant")) {
                const variantId = Number(e.target.value);
                newVariant = this.variantData && this.variantData.find(v => v.id === variantId)
            } else {
                target.tagName === "SELECT" && (target = target.querySelectorAll("option")[target.selectedIndex]),
                target.classList.contains("m-product-option--node__label") || (target = target.closest(".m-product-option--node__label"),
                target || console.error("Unable to find option node!"));
                const {optionPosition} = target.dataset
                  , currActiveOptNode = this.activeOptionNodeByPosition[optionPosition];
                this.toggleOptionNodeActive(currActiveOptNode, !1),
                this.toggleOptionNodeActive(target, !0),
                newVariant = this.getVariantFromActiveOptions()
            }
            console.log('newVariant',newVariant);
            const {variantIdNode} = this;
            this.currentVariant = newVariant;
            variantIdNode && (variantIdNode.setAttribute("value", String(newVariant.id)),
            variantIdNode.value = String(newVariant.id)),
            this.updateBySelectedVariant(newVariant),
            this.hideSoldOutAndUnavailableOptions();
        }
        updateBySelectedVariant(variant) {
            variant && (this.changeProductImage(variant),
            this.updatePrice(variant),this.updateSoldOutBadgeCustom(variant))
        }
        updateSoldOutBadge(variants) {
            let soldOut = !0;
            for (let i = 0; i < variants.length; i++)
                if (variants[i].available) {
                    soldOut = !1;
                    break
                }
            this.domNodes.soldOutBadge && (this.domNodes.soldOutBadge.style.display = soldOut ? "flex" : "none")
        }
        
        updateSoldOutBadgeCustom(variant) {
            let soldOut = true;
            if(variant.available){
              soldOut = false;
            }
            this.domNodes.soldOutBadge && (this.domNodes.soldOutBadge.style.display = soldOut ? "flex" : "none");
          if(this.atcBtn){
            if(soldOut){
              this.atcBtn.setAttribute('disabled',true)
            }
            else{
              this.atcBtn.removeAttribute('disabled')
            }
          }
        }
        getVariantsByActiveOptionValue = value => {
            const {productData: {variants}={}} = this;
            return variants.filter(variant => variant.options.indexOf(value) !== -1)
        }
        ;
        changeProductImage(variant) {
            const src = variant && variant.featured_image && variant.featured_image.src
              , {featuredImage} = this
              , img = featuredImage && featuredImage.querySelector("img");
            img && src && (img.src = `${src}&width=533`,
            img.removeAttribute("srcset"))
        }
      
        hideSoldOutAndUnavailableOptions() {
            const classes = {
                soldOut: "m-product-option--node__soldout",
                unavailable: "m-product-option--node__unavailable"
            }
              , {optionNodes} = this.domNodes
              , {options} = this.productData;
          const variants = this.variantData;
            optionNodes.forEach(optNode => {
                const {optionPosition, value} = optNode.dataset
                  , optPos = Number(optionPosition)
                  , isSelectOption = optNode.tagName === "OPTION";
                let matchVariants = [];
                if (optPos === options.length) {
                    const optionsArray = [...this.currentVariant.options];
                    optionsArray[optPos - 1] = value,
                    matchVariants.push(getVariantFromOptionArrayCustom(this.variantData, optionsArray))
                } else
                    matchVariants = variants.filter(v => v.options[optPos - 1] === value && v.options[optPos - 2] === this.currentVariant[`option${optPos - 1}`]);
                if (matchVariants = matchVariants.filter(Boolean),
                matchVariants.length) {
                    optNode.classList.remove(classes.unavailable),
                    isSelectOption && optNode.removeAttribute("disabled");
                    const method = matchVariants.every(v => !v.available) ? "add" : "remove";
                    optNode.classList[method](classes.soldOut)
                } else
                    optNode.classList.add(classes.unavailable),
                    isSelectOption && optNode.setAttribute("disabled", "true")
            }
            )
        } 
        updatePrice(variant) {
            if (MinimogSettings.pcard_show_lowest_prices)
                return;
                const classes = {
                    onSale: "m-price--on-sale",
                    soldOut: "m-price--sold-out"
                }
              , money_format = window.MinimogSettings.money_format
              , {priceWrapper, salePrice, unitPrice, compareAtPrice,discountBadge} = this.domNodes
              , {compare_at_price, price, unit_price_measurement} = variant
              , onSale = compare_at_price && compare_at_price > price
              , soldOut = !variant.available;
            if(discountBadge){
            if(onSale){
                discountBadge.style.display = '';
                discountBadge.innerHTML = Math.round((100 * (compare_at_price - price)) / compare_at_price) + "% OFF";
                }else{
                discountBadge.style.display = 'none';
                }
                };
            if (onSale ? priceWrapper && priceWrapper.classList.add(classes.onSale) : priceWrapper && priceWrapper.classList.remove(classes.onSale),
            soldOut ? priceWrapper && priceWrapper.classList.add(classes.soldOut) : priceWrapper && priceWrapper.classList.remove(classes.soldOut),
            priceWrapper && priceWrapper.classList.remove("visibility-hidden"),
            salePrice && (salePrice.innerHTML = formatMoney(price, money_format)),
            compareAtPrice && compareAtPrice.length && compare_at_price > price ? compareAtPrice.forEach(item => item.innerHTML = formatMoney(compare_at_price, money_format)) : compareAtPrice.forEach(item => item.innerHTML = formatMoney(price, money_format)),
            unit_price_measurement && unitPrice && this.currentVariant) {
                unitPrice.classList.remove("f-hidden");
                const unitPriceContent = `<span>${formatMoney(this.currentVariant.unit_price, money_format)}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
                unitPrice.innerHTML = unitPriceContent
            } else
                unitPrice && unitPrice.classList.add("f-hidden")
        }
        _getBaseUnit = () => this.currentVariant.unit_price_measurement.reference_value === 1 ? this.currentVariant.unit_price_measurement.reference_unit : this.currentVariant.unit_price_measurement.reference_value + this.currentVariant.unit_price_measurement.reference_unit
        
    }
    if (customElements.define("pcard-swatch", PcardColorSwatch),
    !customElements.get("swatch-button")) {
        class PcardVariantButton extends HTMLElement {
            constructor() {
                super()
            }
        }
        if (customElements.define("swatch-button", PcardVariantButton),
        !customElements.get("swatch-dropdown")) {
            class PcardVariantSelect extends PcardVariantButton {
                constructor() {
                    super()
                }
            }
            customElements.define("swatch-dropdown", PcardVariantSelect)
        }
        if (!customElements.get("swatch-image")) {
            class PcardVariantImage extends PcardVariantButton {
                constructor() {
                    super()
                }
            }
            customElements.define("swatch-image", PcardVariantImage)
        }
        if (!customElements.get("swatch-color")) {
            class PcardVariantColor extends PcardVariantButton {
                constructor() {
                    super()
                }
            }
            customElements.define("swatch-color", PcardVariantColor)
        }
    }
  
}
//# sourceMappingURL=/cdn/shop/t/15/assets/product-card-swatch.js.map?v=6756552952392237561720077091

// if (!customElements.get("pcard-swatch")) {
//   class t extends HTMLElement {
//     constructor() {
//       super(),
//         (this.selectors = {
//           container: "[data-pcard-variant-picker]",
//           optionNodes: [".m-product-option--node__label"],
//           featuredImage: ".m-product-card__main-image",
//           pcard: ".m-product-card",
//           variantDropdown: ".m-product-option--dropdown-select",
//           priceWrapper: ".m-price",
//           salePrice: ".m-price-item--sale",
//           compareAtPrice: [".m-price-item--regular"],
//           unitPrice: ".m-price__unit",
//           soldOutBadge: ".m-product-tag--soldout",
//         }),
//         (this.container = this.closest(this.selectors.container)),
//         (this.pcard = this.closest(this.selectors.pcard)),
//         (this.variantIdNode =
//           this.pcard && this.pcard.querySelector('[name="id"]')),
//         (this.featuredImage =
//           this.pcard && this.pcard.querySelector(this.selectors.featuredImage)),
//         (this.domNodes = queryDomNodes(this.selectors, this.pcard)),
//         this.setupData();
//     }
//     async setupData() {
//       console.log('this.getVariantData()',this.getVariantData()),
//       (this.variantData = this.getVariantData()),
//         (this.productHandle = this.container.dataset.productHandle),
//         (this.productData = await this.getProductJson()),
//         (this.activeOptionNodeByPosition = {}),
//         (this.hide_unavailable_product_options =
//           MinimogSettings.hide_unavailable_product_options);
//       const {
//         variantIdNode: t,
//         productData: e,
//         productData: { variants: a } = {},
//       } = this;
//       if (e) {
//         let i = t && Number(t.value);
//         i ||
//           (i =
//             e.selected_or_first_available_variant &&
//             e.selected_or_first_available_variant.id);
//         const s = a.find((t) => t.id === i) || a[0];
//         (this.productData.initialVariant = s),
//           !this.productData.selected_variant &&
//             t &&
//             t.dataset.selectedVariant &&
//             (this.productData.selected_variant = a.find(
//               (e) => e.id === Number(t && t.dataset.selectedVariant)
//             )),
//           this.updateOptionByVariant(s),
//           window.MinimogEvents.subscribe("m:image-loaded", () => {
//             this.changeProductImage(s);
//           });
//       }
//       this.initOptionSwatches(),
//         this.domNodes.optionNodes &&
//           this.domNodes.optionNodes.forEach((t) =>
//             t.addEventListener("click", this.handleSelectVariant.bind(this))
//           ),
//         this.domNodes.variantDropdown &&
//           this.domNodes.variantDropdown.addEventListener(
//             "change",
//             this.handleSelectVariant.bind(this)
//           );
//       // if(this.querySelector('[data-store-code]')){
//       //   this.querySelector('[data-store-code]').click()
//       // }
//     }
//     getVariantData() {
//       return (
//         (this.variantData =
//           this.variantData ||
//           JSON.parse(
//             this.container &&
//               this.container.querySelector('[type="application/json"]')
//                 .textContent
//           )),
//         this.variantData
//       );
//     }
//     getProductJson() {
//       let t = `${window.MinimogSettings.routes.root}/products/${this.productHandle}.js`;
//       return (
//         (t = t.replace("//", "/")),
//         fetch(t).then(function (t) {
//           return t.json();
//         })
//       );
//     }
//     initOptionSwatches() {
//       const { _colorSwatches: t = [], _imageSwatches: e = [] } =
//         window.MinimogSettings;
//       this.domNodes.optionNodes.forEach((a) => {
//         const { optionType: i, optionPosition: s, value: o } = a && a.dataset,
//           n = o && o.toLowerCase(),
//           r = this.variantData.find((t) => t[`option${s}`] === o),
//           c =
//             r && r.featured_image && r.featured_image.src
//               ? getSizedImageUrl(r.featured_image.src, "60x")
//               : null,
//           d = e.find((t) => t.key === n) && e.find((t) => t.key === n).value,
//           l = t.find((t) => t.key === n) && t.find((t) => t.key === n).value;
//         switch (((c || d) && a.classList.add("has-bg-img"), i)) {
//           case "default":
//             (d || c) && (a.style.backgroundImage = `url(${d || c || ""})`);
//             break;
//           case "image":
//             (c || d) && (a.style.backgroundImage = `url(${c || d || ""})`);
//             break;
//           case "color":
//             (a.style.background = `${l || n}`),
//               d && (a.style.backgroundImage = `url(${d})`);
//         }
//       });
//     }
//     toggleOptionNodeActive(t, e) {
//       if (t)
//         if (e) {
//           const { optionPosition: e, value: a } = t.dataset;
//           switch (((this.activeOptionNodeByPosition[e] = t), t.tagName)) {
//             case "INPUT":
//               (t.checked = "checked"), (t.dataset.selected = "true");
//               break;
//             case "OPTION":
//               t.dataset.selected = "true";
//               const e = t.closest("select");
//               e && (e.value = t.value);
//               break;
//             case "LABEL":
//               t.dataset.selected = "true";
//               break;
//             default:
//               t.classList.contains("m-product-quickview-button");
//           }
//           this.updateSoldOutBadge(this.getVariantsByActiveOptionValue(a));
//         } else {
//           ["default", "image", "color"].includes(t.dataset.optionType) ||
//             (t.style.border = ""),
//             (t.checked = !1),
//             delete t.dataset.selected;
//           const e = t.closest("select");
//           e && (e.value = "");
//         }
//     }
//     updateOptionByVariant(t) {
//       console.log('this.activeOptionNodeByPosition',this.activeOptionNodeByPosition)
//       Object.values(this.activeOptionNodeByPosition).forEach((t) =>
//         this.toggleOptionNodeActive(t, !1)
//       );
//       const { optionNodes: e } = this.domNodes,
//         { options: a = [] } = t || {};
//       a.forEach((t, a) => {
//         const i = a + 1;
//         e.forEach((e) => {
//           const a = Number(e.dataset.optionPosition),
//             s = e.dataset.value;
//           a === i && t === s && this.toggleOptionNodeActive(e, !0);
//         });
//       }),
//         this.updatePrice(t);
//     }
//     getVariantFromActiveOptions = () => {
//       const {
//         productData: t,
//         productData: { initialVariant: e },
//         activeOptionNodeByPosition: a,
//       } = this;
//       let i;
//       const s = { 1: e.option1, 2: e.option2, 3: e.option3 };
//       Object.values(a).forEach((t) => {
//         const { optionPosition: e, value: a } = t.dataset;
//         s[e] = a;
//       }),
//         (i = Object.values(s)),
//         (i = i.filter(Boolean));
//       let o = getVariantFromOptionArray(t, i);
//       return (
//         !o &&
//           this.hide_unavailable_product_options &&
//           (i.pop(),
//           (o = getVariantFromOptionArray(t, i)),
//           o || (i.pop(), (o = getVariantFromOptionArray(t, i)))),
//         (this.currentVariant = o),
//         o
//       );
//     };
//     handleSelectVariant(t) {
//         console.log('this.productData',this.productData,t,t.target.value, Number(t.target.value));
//       let e,
//         { target: a } = t;
//       if (a.classList.contains("combined-variant")) {
//         const a = Number(t.target.value);
//         e =
//           this.productData &&
//           this.productData.variants &&
//           this.productData.variants.find((t) => t.id === a);
//       } else {
//         "SELECT" === a.tagName &&
//           (a = a.querySelectorAll("option")[a.selectedIndex]),
//           a.classList.contains("m-product-option--node__label") ||
//             (a = a.closest(".m-product-option--node__label"));
//         const { optionPosition: t } = a.dataset,
//           i = this.activeOptionNodeByPosition[t];
//         this.toggleOptionNodeActive(i, !1),
//           this.toggleOptionNodeActive(a, !0),
//           (e = this.getVariantFromActiveOptions());
//       }
//       const { variantIdNode: i } = this;
//       i && (i.setAttribute("value", String(e.id)), (i.value = String(e.id))),
//         this.updateBySelectedVariant(e);
//     }
//     updateBySelectedVariant(t) {
//       t && (this.changeProductImage(t), this.updatePrice(t));
//     }
//     updateProductCardSoldOutBadge(t) {
//       this.domNodes.soldOutBadge &&
//         (this.domNodes.soldOutBadge.style.display = t.available
//           ? "none"
//           : "flex");
//       if(this.pcard){
//         if(t.available){
//           this.pcard.classList.remove('variant-not-available')
//         }else{
//           this.pcard.classList.add('variant-not-available')
//         }
//       }
//     }
//     updateSoldOutBadge(t) {
//       let e = !0;
//       for (let a = 0; a < t.length; a++)
//         if (t[a].available) {
//           e = !1;
//           break;
//         }
//       this.domNodes.soldOutBadge &&
//         (this.domNodes.soldOutBadge.style.display = e ? "flex" : "none");
//       if(this.pcard){
//         if(e){
//           this.pcard.classList.add('variant-not-available')
//         }else{
//           this.pcard.classList.remove('variant-not-available')
//         }
//       }
//     }
//     getVariantsByActiveOptionValue = (t) => {
//       const { productData: { variants: e } = {} } = this;
//       return e.filter((e) => -1 !== e.options.indexOf(t));
//     };
//     changeProductImage(t) {
//       const e = t && t.featured_image && t.featured_image.src,
//         { featuredImage: a } = this,
//         i = a && a.querySelector("img");
//       i && e && ((i.src = `${e}&width=533`), i.removeAttribute("srcset"));
//     }
//     updatePrice(t) {
//       if (MinimogSettings.pcard_show_lowest_prices) return;
//       const e = "m-price--on-sale",
//         a = "m-price--sold-out",
//         i = window.MinimogSettings.money_format,
//         {
//           priceWrapper: s,
//           salePrice: o,
//           unitPrice: n,
//           compareAtPrice: r,
//         } = this.domNodes,
//         { compare_at_price: c, price: d, unit_price_measurement: l } = t,
//         u = c && c > d,
//         p = !t.available;
//       if (
//         (u ? s && s.classList.add(e) : s && s.classList.remove(e),
//         p ? s && s.classList.add(a) : s && s.classList.remove(a),
//         s && s.classList.remove("visibility-hidden"),
//         o && (o.innerHTML = formatMoney(d, i)),
//         r && r.length && c > d
//           ? r.forEach((t) => (t.innerHTML = formatMoney(c, i)))
//           : r.forEach((t) => (t.innerHTML = formatMoney(d, i))),
//         l && n && this.currentVariant)
//       ) {
//         n.classList.remove("f-hidden");
//         const t = `<span>${formatMoney(
//           this.currentVariant.unit_price,
//           i
//         )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
//         n.innerHTML = t;
//       } else n && n.classList.add("f-hidden");
//     }
//     _getBaseUnit = () =>
//       1 === this.currentVariant.unit_price_measurement.reference_value
//         ? this.currentVariant.unit_price_measurement.reference_unit
//         : this.currentVariant.unit_price_measurement.reference_value +
//           this.currentVariant.unit_price_measurement.reference_unit;
//   }
//   if (
//     (customElements.define("pcard-swatch", t),
//     !customElements.get("swatch-button"))
//   ) {
//     class t extends HTMLElement {
//       constructor() {
//         super();
//       }
//     }
//     if (
//       (customElements.define("swatch-button", t),
//       !customElements.get("swatch-dropdown"))
//     ) {
//       class e extends t {
//         constructor() {
//           super();
//         }
//       }
//       customElements.define("swatch-dropdown", e);
//     }
//     if (!customElements.get("swatch-image")) {
//       class e extends t {
//         constructor() {
//           super();
//         }
//       }
//       customElements.define("swatch-image", e);
//     }
//     if (!customElements.get("swatch-color")) {
//       class e extends t {
//         constructor() {
//           super();
//         }
//       }
//       customElements.define("swatch-color", e);
//     }
//   }
// }
